import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

export interface AppSettings {
    title: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {

    public appSettings: AppSettings;
  constructor(private firestore: AngularFirestore) {
      this.getSettings();
   }

   getSettings(): Promise<AppSettings> {
       return new Promise((resolve, reject) => {
        return this.firestore.collection('settings').get().toPromise().then(res => {
            if (res && res.docs && res.docs && res.docs.length > 0) {
                this.appSettings = res.docs[0].data() as AppSettings;
                resolve(this.appSettings);
            }
        }).catch(err => {
            console.log(err);
        });
       });
  }
}
